// this function generates random ids for html elements, not a huge security risk
// should be marked as false positive in security scans
export const newGuid = () => {
  const s4 = () => {
    const rng = window.crypto || window.msCrypto;

    if (rng === undefined) {
    // use less secure Math.random() function if browser doesn't support crypto
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return Math.floor(rng.getRandomValues(new Uint32Array(1))[0] * 0x10000)
      .toString(16)
      .substring(1);
  };

  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const flattenObject = (obj) => {
  let s = '';
  const what = Object.prototype.toString.call(obj);
  switch (what) {
    case '[object Object]':
      for (const p in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, p)) {
          continue;
        }
        s += `${(s.length === 0 ? '' : '.') + p}.${flattenObject(obj[p])}`;
      }
      break;
    case '[object String]':
      s += (s.length === 0 ? '' : '.') + obj;
      break;
    case '[object Array]':
      obj.forEach((x) => {
        s += (s.length === 0 ? '' : '.') + flattenObject(x);
      });
      break;
    default:
      break;
  }

  return s;
};

export const mergeError = (previous, error) => {
  const codes = [];
  const errorString = flattenObject(error);

  // Clean up any errors which are no longer valid
  previous.forEach((c) => {
    if (errorString && errorString.endsWith('.') && c.indexOf(errorString) > -1) {
      return;
    }

    codes.push(c);
  });

  // Add the error if it does not already exist
  if (
    errorString
    && errorString.length
    && !errorString.endsWith('.')
    && !codes.includes(errorString)
  ) {
    codes.push(errorString);
  }
  return codes;
};

export const triageErrors = (section, previous, codes) => {
  const arr = [];

  // First we need to persist any error messages stored in the same section
  // but not necessarily within the same scope
  previous.forEach((e) => {
    for (const subsection in codes) {
      if (Object.prototype.hasOwnProperty.call(codes, subsection) && e.indexOf(`${subsection}.`) === -1) {
        arr.push(e.replace(`${section}.`, ''));
      }
    }
  });

  for (const subsection in codes) {
    // skip loop if the property is from prototype
    if (Object.prototype.hasOwnProperty.call(codes, subsection) && codes[subsection]) {
      for (const prop in codes[subsection]) {
        if (Object.prototype.hasOwnProperty.call(codes[subsection], prop)) {
          const e = `${subsection}.${flattenObject(codes[subsection][prop])}`;
          if (!arr.includes(e)) {
            arr.push(e);
          }
        }
      }
    }
  }
  return arr;
};
